import { EActions } from "redux/actions/EActions";
import { IAttachment } from "models/attachment";

export interface IAttachmentState {
  expenses: IAttachment[];
}

const initalState = {
  expenses: [],
};

const reducer = (state: IAttachmentState = initalState, action: any) => {
  switch (action.type) {
    case EActions.ClearExpensesAttachments:
      return {
        ...state,
        expenses: []
      };
    case EActions.GetExpensesAttachments:
      return {
        ...state,
        expenses: action.payload
      };
  }
  return state;
};

export default reducer;
